/**
 * Application configuration using environment variables with fallback defaults
 * This replaces the old global.js approach for better deployment flexibility
 * 
 * Environment variables should be prefixed with REACT_APP_ to be accessible in React
 * Example: REACT_APP_API_URL=https://staging-api.example.com
 */

// Read environment variables via Vite's import.meta.env.
// Only variables prefixed with VITE_ are exposed to the client bundle.
const getEnvVar = (name) => {
  try {
    // Vite always provides import.meta.env, no need for complex checks
    const value = import.meta.env[name];
    const isProd = import.meta.env.PROD;
    
    if (value === undefined || value === null || value === '') {
      const msg = `[config] ${name} not set`;
      isProd ? console.error(msg) : console.warn(msg);
    }
    return value;
  } catch (error) {
    console.warn(`[config] Error accessing ${name}`, error);
  }
};

const config = {
  // Core API Configuration
  apiUrl: getEnvVar('VITE_API_URL'),
  bucket: getEnvVar('VITE_BUCKET'),
  userManualJPN: getEnvVar('VITE_BUCKET_USERMANUAL_JPN'),
  userManualENG: getEnvVar('VITE_BUCKET_USERMANUAL_ENG'),
  
  // AWS Cognito Configuration
  clientId: getEnvVar('VITE_CLIENT_ID'),
  userPoolId: getEnvVar('VITE_USER_POOL_ID'),
  region: getEnvVar('VITE_REGION'),

  geoidRasterJapan:getEnvVar('VITE_GEOID_RASTER_JAPAN'),
  geoidRasterWorld:getEnvVar('VITE_GEOID_RASTER_WORLD'),
  
  // External Service URLs
  userCreationApiUrl: getEnvVar('VITE_USER_CREATION_API_URL'),
  userDeleteApiUrl: getEnvVar('VITE_USER_DELETE_API_URL'),  
  sendInvitationApiUrl: getEnvVar('VITE_EMAIL_INVITATION_API_URL'),  
  cesiumUploadUrl: getEnvVar('VITE_CESIUM_UPLOAD_URL'),
  
  //Cesium Layers
  googlePhotoRealisticTilesetID:2275207,
  japanRegionalTerrain:2767062,
  japan3DBuildingsTilsetID:2602291,
  osmBuildingsTilsetID:96188,

  //List of Cesium AssetsIDs corresponding to the basemaps
  cesiumBasemapIDs:[1,2,3,4,3812,3813,3845,3954,2411391,96188,2602291,2767062,2275207],

  // S3 Directory Structure Constants
  // These define the folder organization in the S3 bucket
  dirs: {
    products: 'products',  // Processed/output files
    uploads: 'uploads',    // Raw uploaded files
    views: 'views',         // Visualization/preview files
    documents: 'documents',  // Processed/output files
    raster: 'raster'
  },
  
  // Service Type Constants
  // Defines the different application modes available
  services: {
    classic: 'classic',    // Traditional point cloud processing
    mapping: 'mapping'     // Mapping/GIS focused features
  }
};

export default config;
